import { ArrowRight, CursorClick, Eye, Globe, PaintBrush, Users } from '@phosphor-icons/react';
import { Box, Button, Card, CardContent, Container, Stack, Typography } from '@mui/material';
import { SectionEyebrow } from '@scoutingops/ui';

const HUB_URL = (import.meta.env.VITE_HUB_URL ?? "https://scoutingops.com") as string;

const leaderSteps = [
  { icon: CursorClick, text: 'Pick your program and unit type \u2014 Pack, Troop, Crew, Ship, Post, and more' },
  { icon: PaintBrush, text: 'Customize the pre-filled pages with your unit\u2019s info and photos' },
  { icon: Eye, text: 'Preview your site exactly as families will see it' },
  { icon: Globe, text: 'Publish instantly on a free Scouting Ops Site URL or your own domain' },
];

const familySteps = [
  { icon: Globe, text: 'Find your unit\u2019s site via search or a shared link' },
  { icon: Eye, text: 'See meeting times, events, and what the program is about' },
  { icon: Users, text: 'Use the contact form or join button to get started' },
];

export default function HowItWorksSection() {
  return (
    <Box component="section" sx={{ py: { xs: 10, md: 14 }, bgcolor: 'action.hover' }}>
      <Container maxWidth="lg">
        <Stack spacing={1.5} sx={{ alignItems: 'center', textAlign: 'center', mb: 7 }}>
          <SectionEyebrow>Up and Running Fast</SectionEyebrow>
          <Typography variant="h3" sx={{ fontWeight: 800 }}>How It Works</Typography>
        </Stack>

        <Box
          sx={{
            display: 'grid',
            gap: 2.5,
            maxWidth: 980,
            mx: 'auto',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(2,minmax(0,1fr))' },
          }}
        >
          <Card variant="outlined" sx={{ borderTop: '3px solid', borderColor: 'primary.main' }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ mb: 2.5, color: 'primary.main', fontWeight: 700 }}>For Unit Leaders</Typography>
              <Stack component="ol" spacing={2} sx={{ m: 0, pl: 0, listStyle: 'none' }}>
                {leaderSteps.map((step, index) => (
                  <Stack component="li" direction="row" spacing={1.5} key={step.text} sx={{ alignItems: 'flex-start' }}>
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '999px',
                        display: 'grid',
                        placeItems: 'center',
                        bgcolor: 'action.hover',
                        color: 'primary.main',
                        fontSize: '0.78rem',
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      {index + 1}
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ pt: 0.25 }}>{step.text}</Typography>
                  </Stack>
                ))}
              </Stack>
              <Button
                component="a"
                href={`${HUB_URL}/auth/sign-in`}
                variant="contained"
                size="small"
                endIcon={<ArrowRight size={14} />}
                sx={{ mt: 3 }}
              >
                Get Started
              </Button>
            </CardContent>
          </Card>

          <Card variant="outlined" sx={{ borderTop: '3px solid', borderColor: 'success.main' }}>
            <CardContent sx={{ p: 3 }}>
              <Typography variant="h5" sx={{ mb: 2.5, color: 'success.main', fontWeight: 700 }}>For Families</Typography>
              <Stack component="ol" spacing={2} sx={{ m: 0, pl: 0, listStyle: 'none' }}>
                {familySteps.map((step, index) => (
                  <Stack component="li" direction="row" spacing={1.5} key={step.text} sx={{ alignItems: 'flex-start' }}>
                    <Box
                      sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '999px',
                        display: 'grid',
                        placeItems: 'center',
                        bgcolor: 'action.hover',
                        color: 'success.main',
                        fontSize: '0.78rem',
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      {index + 1}
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ pt: 0.25 }}>{step.text}</Typography>
                  </Stack>
                ))}
              </Stack>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </Box>
  );
}
